import { defineStore } from "pinia";
import { ref } from "vue";
import { useOfflineCompat } from "@/composables/useOfflineCompat";
import { useRest } from "@/composables/useRest";

export const usePersonalFiscalStore = defineStore("personalFiscal", () => {
  const fiscales = ref([]);
  const ayudantesFiscales = ref([]);
  const fiscalesListLoad = ref(false);
  const ayudantesFiscalesListLoad = ref(false);

  const offline = useOfflineCompat();
  const rest = useRest();

  /**
   * Obtiene personal fiscal según el tipo (Fiscal o Ayudante Fiscal)
   * @param {Object} type - Objeto con propiedades { en: string, es: string }
   *   - en: nombre en inglés para el key (ej: "prosecutors", "assistants")
   *   - es: jerarquía en español (ej: "Fiscal", "Ayudante Fiscal")
   * @param {Boolean} refresh - Si debe refrescar los datos
   */
  async function setPersonalFiscal(type, refresh = false) {
    try {
      let datos = [];
      const listLoadKey = type.en === "prosecutors" ? fiscalesListLoad : ayudantesFiscalesListLoad;

      if (listLoadKey.value && !refresh) return;

      if (!refresh && offline.offlineServer) {
        let r = await offline.getList(type.en);
        if (Array.isArray(r.data.data) && r.data.data.length > 0 && r.data.data[0].list) {
          datos = r.data.data[0].list;
        }
      }

      if (!datos || refresh || datos.length < 1) {
        const url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/personalfiscal?search={"Jerarquia": [{"operator": "=", "value": "${type.es}"}]}`;
        const r = await rest.get({ url });
        datos = r.data.data;
        offline.setList(type.en, datos);
      }
      if (type.en === "prosecutors") {
        fiscales.value = datos;
        fiscalesListLoad.value = true;
      } else if (type.en === "assistants") {
        ayudantesFiscales.value = datos;
        ayudantesFiscalesListLoad.value = true;
      }
    } catch (e) {
      console.error("setPersonalFiscal>>", e);
    }
  }

  async function setFiscales(refresh = false) {
    await setPersonalFiscal({ en: "prosecutors", es: "Fiscal" }, refresh);
  }

  async function setAyudantesFiscales(refresh = false) {
    await setPersonalFiscal({ en: "assistants", es: "ayudante" }, refresh);
  }

  return {
    // State
    fiscales,
    ayudantesFiscales,
    fiscalesListLoad,
    ayudantesFiscalesListLoad,

    // Actions
    setPersonalFiscal,
    setFiscales,
    setAyudantesFiscales,
  };
});
